import Vue from 'vue'
import axios from 'axios'
import VueRouter from 'vue-router'
import Config from '@/components/Config.vue'
import AppHome from '@/components/AppHome.vue'
import Home from '@/components/Home.vue'
import AuditHome from '@/components/AuditHome.vue'
import { saveLogToLocal } from '@/utils'
import { i18n } from '@/locale/i18n/i18n'
import { Dialog } from 'vant'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  if (this.history.current.name == location.name) {
    // VueRouter.reload()
  } else {
    originalPush.call(this, location)
    // originalPush(this,location)
  }
}

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location, onResolve, onReject) {
//   debugger
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }

Vue.use(VueRouter)

function getQuery(to) {
  const { query } = to
  const keys = Object.keys(query)
  if (!keys.length) return ''
  const queryStr = keys.map((key) => `${key}=${query[key]}`).join('&')
  return `?${queryStr}`
}

function jump(path) {
  const url = `${Config.auditUrl}${path}`
  location.href = url
}

const routes = [
  {
    path: '/webs',
    name: 'webs',
    component: () => import('@/views/app/webs'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/app/login'),
  },
  {
    path: '/logs',
    name: 'logs',
    component: () => import('@/views/app/logs'),
  },
  // {
  //   path: '/test',
  //   name: 'login',
  //   component: () => import('@/views/app/test')
  // },
  // {
  //   path: '/err',
  //   name: 'err',
  //   component: () => import('@/views/app/err')
  // },
  {
    path: '/app',
    name: 'AppHome',
    component: AppHome,
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/app/index'),
      },
      {
        path: 'redline',
        name: 'redline',
        component: () => import('@/views/app/redline'),
      },
      {
        path: 'noticeDetail',
        name: 'noticeDetail',
        component: () => import('@/views/app/noticeDetail'),
      },
      {
        path: 'complaint',
        name: 'complaint',
        component: () => import('@/views/app/complaint'),
      },
      {
        path: 'complaintDetail',
        name: 'complaintDetail',
        component: () => import('@/views/app/complaint'),
      },
      {
        path: 'table',
        name: 'table',
        component: () => import('@/views/app/table'),
      },
      {
        path: 'info',
        name: 'info',
        component: () => import('@/views/app/info'),
      },
      {
        path: 'auth',
        name: 'auth',
        component: () => import('@/views/app/auth'),
      },
      {
        path: 'cashGift',
        name: 'cashGift',
        component: () => import('@/views/app/cashGift'),
      },
      {
        path: 'interest',
        name: 'interest',
        component: () => import('@/views/app/interest'),
      },
      {
        path: 'interest_en',
        name: 'interest_en',
        component: () => import('@/views/app/interest'),
      },
      {
        path: 'interest_en_back',
        name: 'interest_en_back',
        component: () => import('@/views/app/interest_en_back250225'),
      },
      {
        path: 'cashGiftTable',
        name: 'cashGiftTable',
        component: () => import('@/views/app/cashGiftTable'),
      },
    ],
  },
  {
    path: '/main',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'tsArticle',
        name: 'tsArticle',
        component: () => import('@/views/ts/tsArticle'),
      },
      {
        path: 'tsComplaint',
        name: 'tsComplaint',
        component: () => import('@/views/ts/tsComplaint'),
      },
      {
        path: 'tsCashGift',
        name: 'tsCashGift',
        component: () => import('@/views/ts/tsCashGift'),
        beforeEnter(to) {
          jump(`/supervise/gift${getQuery(to)}`)
        },
      },
      {
        path: 'tsInterest',
        name: 'tsInterest',
        component: () => import('@/views/ts/tsInterest'),
        beforeEnter(to) {
          jump(`/supervise/conflict${getQuery(to)}`)
        },
      },
      {
        path: 'test',
        name: 'test',
        component: () => import('@/views/ts/test'),
      },
      {
        path: 'cashGiftHandle',
        name: 'cashGiftHandle',
        component: () => import('@/views/ts/cashGiftHandle'),
      },
    ],
  },
  {
    path: '/audit',
    name: 'AuditHome',
    component: AuditHome,
    children: [
      {
        path: 'ld',
        name: 'ld',
        component: () => import('@/views/audit/job/ld'),
      },
      {
        path: 'tb',
        name: 'tb',
        component: () => import('@/views/audit/job/tb'),
      },
      {
        path: 'zg',
        name: 'zg',
        component: () => import('@/views/audit/job/zg'),
      },
      {
        path: 'file',
        name: 'file',
        component: () => import('@/views/audit/job/file'),
      },
      {
        path: 'test',
        name: 'test',
        component: () => import('@/views/audit/job/test'),
      },
      {
        path: 'problemDetail',
        name: 'problemDetail',
        component: () => import('@/views/audit/approve/problemDetail'),
      },
      {
        path: 'projectApproval',
        name: 'projectApproval',
        component: () => import('@/views/audit/approve/projectApproval'),
      },
      {
        path: 'nonProjectIssues',
        name: 'nonProjectIssues',
        component: () => import('@/views/audit/approve/nonProjectIssues'),
      },
      {
        path: 'detailedReport',
        name: 'detailedReport',
        component: () => import('@/views/audit/approve/detailedReport'),
      },
      {
        path: 'problemRectify',
        name: 'problemRectify',
        component: () => import('@/views/audit/approve/problemRectify'),
      },
      {
        path: 'tdSso',
        name: 'tdSso',
        component: () => import('@/views/audit/sso/tdSso'),
      },
    ],
  },
  // {
  //   path: '*',
  //   name: 'login',
  //   component: () => import('@/views/app/login')
  // }
]
const router = new VueRouter({
  mode: 'history',
  routes,
})

// 路由之前首先验证是否登录
// 如果网关返回已登录，直接放行，否则跳转登录页
// 如果没有登录跳转到sso CheckLogin
// 在网关验证session的时候，其实和后续页面访问的session是同一个，这就解决了href的session变化问题

router.beforeEach((to, from, next) => {
  console.log('router.beforeEach', to.fullPath, to)
  i18n.locale = localStorage.lang || 'zh'
  const isApp = !(to.fullPath && to.fullPath.startsWith('/main'))
  if (to && (to.name == 'login' || to.name == 'tdSso')) {
    next()
  } else {
    const path = to.fullPath
    axios.get('/api/sso?validUser=true').then((res) => {
      if (res.data === 'illegalAccess' || !res.data) {
        const token = to.query.token
        if (token === undefined) {
          if (isApp) {
            router.push({
              name: 'login',
              query: {
                refer: window.location.href,
              },
            })
          } else {
            let url = Config.ssoUrl + '/checkLogin?refer='
            url = url + Config.tsUrl + path
            window.location.href = url
          }
        } else {
          axios.get('/api/sso?validUser=true&token=' + token).then((res) => {
            if (res.data !== 'illegalAccess') {
              saveLog(to)
              next()
            } else {
              if (isApp) {
                router.push({
                  name: 'login',
                  query: {
                    refer: window.location.href,
                  },
                })
              } else {
                let url = Config.ssoUrl + '/login?refer='
                url = url + Config.tsUrl + path
                window.location.href = url
              }
            }
          })
        }
      } else {
        if (!to.name) {
          router.push({
            name: 'index',
          })
          return
        }
        saveLog(to)
        next()
      }
    })
  }
})
let guid
let heartBeatTask = null
let m = 5 //单位 秒
let pageDuration = 0
function saveLog(to) {
  try {
    axios
      .post('/api/rbac/v0.1/sysLog/save', {
        logType: '菜单日志',
        result: to.path,
        appId: 'ts',
        params: decodeURI(window.location.origin + to.fullPath),
      })
      .then((res) => {
        guid = res.data
        initTask()
      })
  } catch (err) {
    console.log('saveLog:' + err)
  }
}
function initTask() {
  if (!guid) {
    return
  }
  if (heartBeatTask) {
    return
  }
  heartBeatTask = setInterval(() => {
    pageDuration += m
    if (pageDuration % 60 != 0) {
      return
    }
    console.log('计数：', pageDuration)
    send()
  }, m * 1000)
}
function send() {
  if (!guid) {
    return
  }
  axios.get('/api/rbac/v0.1/sysLog/heartBeat', {
    params: {
      guid: guid,
      time: pageDuration,
    },
  })
}
document.addEventListener('visibilitychange', (event) => {
  if (document.hidden) {
    clearInterval(heartBeatTask)
    heartBeatTask = null
    send()
  } else {
    initTask()
  }
})

export default router
